'use strict';

var canDistinguishSparseFromUndefined = 0 in [undefined]; // IE 6 - 8 have a bug where this returns false

module.exports = function isStringOrHole(item, index, arr) {
	return typeof item === 'string' || (canDistinguishSparseFromUndefined ? !(index in arr) : typeof item === 'undefined');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/helpers/isStringOrHole.js
// module id = 949
// module chunks = 0